"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMMUTABLE_FIELDS = exports.REQUIRED_FIELDS = exports.OCCUPANCY_INSPECTION_RESULTS = exports.ORDERED_OCCUPANCY_INSPECTION_STATUSES = exports.OCCUPANCY_INSPECTION_STATUSES = void 0;
exports.OCCUPANCY_INSPECTION_STATUSES = {
    PENDING_BASE_PROJECT_COMPLETION: 'pending_base_project_completion',
    PENDING_APPLICATION: 'pending_application',
    APPLICATION_IN_PROGRESS: 'application_in_progress',
    PENDING_SCHEDULING: 'pending_scheduling',
    SCHEDULED: 'scheduled',
    PENDING_SCOPE: 'pending_scope',
    PENDING_APPROVAL: 'pending_approval',
    PENDING_CONSTRUCTION_START: 'pending_construction_start',
    PENDING_CONSTRUCTION_COMPLETION: 'pending_construction_completion',
    PENDING_QUALITY_CONTROL: 'pending_quality_control',
    PENDING_OCCUPANT_SIGNATURE: 'pending_occupant_signature',
    COMPLETE: 'complete'
};
exports.ORDERED_OCCUPANCY_INSPECTION_STATUSES = [
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_BASE_PROJECT_COMPLETION,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_APPLICATION,
    exports.OCCUPANCY_INSPECTION_STATUSES.APPLICATION_IN_PROGRESS,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_SCHEDULING,
    exports.OCCUPANCY_INSPECTION_STATUSES.SCHEDULED,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_SCOPE,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_APPROVAL,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_CONSTRUCTION_START,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_CONSTRUCTION_COMPLETION,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_QUALITY_CONTROL,
    exports.OCCUPANCY_INSPECTION_STATUSES.PENDING_OCCUPANT_SIGNATURE,
    exports.OCCUPANCY_INSPECTION_STATUSES.COMPLETE
];
exports.OCCUPANCY_INSPECTION_RESULTS = {
    HARD_FAIL: 'hard_fail',
    PASS: 'pass',
    SOFT_FAIL: 'soft_fail'
};
exports.REQUIRED_FIELDS = ['construction_project_id', 'status'];
exports.IMMUTABLE_FIELDS = [
    'id',
    'construction_project_id',
    'municipality_occupancy_inspection_config_id',
    'created_at',
    'updated_at'
];
